<template>
  <v-container fluid class="salesreport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="3" class="d-flex flex-start justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-2"
                @click="findSalesReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/salesreport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="salesreports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="salesreports-table"
              single-select
              item-key="_id"
              sort-by="salesreportname"
              :footer-props="footer"
              :headers="headers"
              :items="salesreports"
              :items-per-page="itemPerPage">
              <template v-slot:item.startdate="{ item }">
                {{ item.startdate!=null ? new Date(item.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.enddate="{ item }">
                {{ item.enddate!=null ? new Date(item.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric'  }) : '' }}
              </template>
              <template v-slot:item.itemimage="{ item }">
                  <img v-bind:src="item.itemimage" alt="" width="60">
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount!==undefined ? (item.amount).toFixed(1) : '' }}
              </template>
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity!==undefined ? (item.quantity).toFixed(1) : '' }}
              </template>
              <template v-slot:item.avgprice="{ item }">
                {{ item.avgprice!==undefined ? (item.avgprice).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="findSalesReportDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Sales Report</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_locations"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_users"
                    v-model="find_query.userid"
                    label="Sales Rep"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_channels"
                    v-model="find_query.channelid"
                    label="Channel"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_brands"
                    v-model="find_query.brandid"
                    label="Brand"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_regions"
                    v-model="find_query.regionid"
                    label="Region"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    dense
                    :items="data_townships"
                    v-model="find_query.townshipid"
                    label="Township"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-switch
                    color="primary"
                    v-model="find_query.isFoc"
                    :value="true"
                    :false-value="false"
                    hint="FOC"
                    persistent-hint
                  ></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="find_query = {}"
            >
              Clear
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findSalesReportDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findSalesReport"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';



export default {
  name: 'SalesReportByItem',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Start', value: 'startdate' },
        { text: 'End', value: 'enddate' },
        { text: 'Channel', value: 'channelname' },
        { text: 'Item', value: 'itemname' },
        { text: '', value: 'itemfoc', width: '8%' },
        { text: 'Qty', value: 'quantity' },
        { text: 'Price', value: 'avgprice' },
        { text: 'Amount', value: 'amount', width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findSalesReportDialog: false,
      find_query: {},
      salesreports: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('SalesReport', ['isDeleting', 'isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('Location', ['locations']),
    ...mapState('Region', ['regions']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
    data_brands(){
      return this.brands.filter(x=>x.brandstatus=='Active' && x.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id};});
    },
    data_channels(){
      return this.saleschannels.filter(x=>x.channelstatus=='Active' || x.channelstatus=='New').map(x => {return {text: x.channelname, value: x._id};});
    },
    data_locations(){
      return this.locations.filter(x=>x.locationstatus=='Active' || x.locationstatus=='New').map(x => {return {text: x.locationname, value: x._id};});
    },
    data_regions(){
      return this.regions.filter(x=>x.regionstatus=='Active' || x.regionstatus=='New').map(x => {return {text: x.regionname, value: x._id};});
    },
    data_townships(){
      return this.townships.filter(x=>x.townshipstatus=='Active' && x.regionid==this.find_query.regionid).map(x => {return {text: x.townshipname, value: x._id};});
    },
    data_users(){
      return this.users.filter(x=>x.userstatus=='Active' && x.locationid==this.find_query.locationid).map(x => {return {text: x.username, value: x._id};});
    }
  },

  methods: {
    ...mapActions('SalesReport', ["getSalesReportByChannelRequest", "findSalesReportByChannelRequest"]),
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    async findSalesReport(){
      this.findSalesReportDialog = false;
      if(Object.keys(this.find_query).length==0){
        let result = await this.getSalesReportByChannelRequest();
        this.salesreports = result;
        this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
      }
      else{
        let result = await this.findSalesReportByChannelRequest(this.find_query);
        this.salesreports = result;
        console.log(this.salesreports)
        this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
      }
    },
    getJson(){
      let json = this.salesreports.map(report=>{return {
        start_date: report.startdate!=null ? new Date(report.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        end_date: report.enddate!=null ? new Date(report.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        channel: report.channelname,
        itemname: report.itemname,
        foc: report.itemfoc,
        quantity: report.quantity, 
        avgprice: report.avgprice ? report.avgprice.toFixed(1) : 0, 
        amount: report.amount
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-report-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    saveExcel() {
      let item = Object.assign({}, this.find_query);
      item.salesreports = this.salesreports;
      this.$router.push({ name: 'SalesReportPrint', params: item })
    },
  },
  async created () {
    this.salesreports  = await this.getSalesReportByChannelRequest();
    this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
    
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
